export default "__VITE_ASSET__mVa232qk__"